export default __webpack_public_path__ + "static/media/Avatar.44bc9f54.svg";